import {
  TrackerMealConnectorApollo,
  TrackerEditMealConnectorApollo,
  useAppContext,
  TrackerRemoveMealConnectorApollo,
  SaveAsUserMealConnectorApollo,
  formatIsoDate,
} from '@front-activerse/common-components';
import { useParams, useLocation } from 'react-router-dom';
import UserMealDetailsContainer from './UserMealDetailsContainer';
import TrackerNoAccess from '../../Tracker/NoAccess/TrackerNoAccess';

const TrackerMealPage: React.FC = () => {
  const { date, mealId } = useParams();
  const dateString = date ? date : formatIsoDate(new Date());
  const { post } = useAppContext();

  const location = useLocation();

  const aiAccess = sessionStorage.getItem('aiAccess');
  const dietAccess = sessionStorage.getItem('dietAccess');

  if (!mealId) {
    return <div>Missing parameters</div>;
  }

  if (aiAccess === 'true' || dietAccess === 'true') {
    return (
      <TrackerMealConnectorApollo mealId={+mealId}>
        {(trackerMealData: any) => (
          <TrackerEditMealConnectorApollo post={post} originalDate={dateString}>
            {({ editMeal }: { editMeal: (input: any) => Promise<any> }) => (
              <TrackerRemoveMealConnectorApollo date={dateString}>
                {({ removeMeal }) => (
                  <SaveAsUserMealConnectorApollo post={post}>
                    {({ saveAsUserMeal }: { saveAsUserMeal: (input: any) => Promise<any> }) => (
                      <UserMealDetailsContainer
                        {...trackerMealData}
                        loading={trackerMealData.loading}
                        editMeal={editMeal}
                        key={location.key}
                        removeMeal={removeMeal}
                        date={dateString}
                        saveAsUserMeal={saveAsUserMeal}
                      />
                    )}
                  </SaveAsUserMealConnectorApollo>
                )}
              </TrackerRemoveMealConnectorApollo>
            )}
          </TrackerEditMealConnectorApollo>
        )}
      </TrackerMealConnectorApollo>
    );
  }

  return <TrackerNoAccess />;
};

export default TrackerMealPage;
